import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/master.scss';
import { GoogleOAuthProvider } from "@react-oauth/google";
// const CLIENT_ID = "907882242489-do7q6qo2sffjmu5ca7700e1l8ocmekf2.apps.googleusercontent.com";
const CLIENT_ID = "655752950199-ietqpjhl54quaqp5504ck63jmuu8ffep.apps.googleusercontent.com"; // Santanu
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
